import { useState, useEffect } from "react";
import {
  Container,
  Stack,
  Button,
  Box,
  CircularProgress,
  Breadcrumbs,
  Link,
  Divider,
} from "@common-ui/ui";
import AddIcon from "@mui/icons-material/Add";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import CreatePlaceDialog from "./CreatePlaceDialog";

import {
  getCustomerPlace,
  updateCustomerPlace,
} from "../../../services/customer";

const DisplayPlaceForm = ({
  orgId,
  handleAddSubPlace,
  selectedPlaceId,
  setSelectedPlaceId,
  addresses,
  setRefresh,
  customerId,
  init,
  doesUserHavePermission,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [place, setPlace] = useState({});
  const [parentName, setParentName] = useState("");
  const [refreshData, setRefreshData] = useState(false);

  const getPlace = async () => {
    try {
      const res = await getCustomerPlace(orgId, customerId, selectedPlaceId);
      setPlace(res?.data ? res?.data[0] : {});
      setIsLoading(false);
    } catch (error) {
      alert(error);
      setPlace({});
      setIsLoading(false);
    }
  };

  const updatePlace = async (attributes) => {
    try {
      const response = await updateCustomerPlace(
        orgId,
        customerId,
        selectedPlaceId,
        attributes
      );
      setRefreshData(false);
      if (response === 200 || response === 204) {
        init();
        setIsLoading(false);
        // setSelectedPlaceId(selectedPlaceId);
        setRefreshData(true);
        setRefresh(true);
      }
    } catch (error) {
      alert(error);
      setIsLoading(false);
      setRefreshData(true);
      setRefresh(true);
    }
  };

  const getParentPlace = async () => {
    try {
      const response = await getCustomerPlace(orgId, customerId, place?.parent);
      if (response && response.data.length) {
        setParentName(response.data[0].name);
      }
    } catch (error) {
      setParentName("--");
    }
  };

  useEffect(() => {
    if (selectedPlaceId) {
      setIsLoading(true);
      setParentName("");
      getPlace();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPlaceId]);

  useEffect(() => {
    if (refreshData) {
      setIsLoading(true);
      getPlace();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshData]);

  useEffect(() => {
    if (Object.keys(place).length !== 0 && place.parent !== null) {
      getParentPlace();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [place]);

  const handleUpdatePlace = (attributes) => {
    updatePlace(attributes);
  };

  return (
    <Container maxWidth="md" component="main">
      {isLoading ? (
        <Box
          component="main"
          sx={{
            alignItems: "center",
            display: "flex",
            flexGrow: 1,
            minHeight: "100%",
          }}
        >
          <Container maxWidth="md" component="main">
            <Box sx={{ my: 3 }}>
              <CircularProgress />
            </Box>
          </Container>
        </Box>
      ) : (
        <Stack direction="column">
          <Breadcrumbs
            aria-label="breadcrumb"
            separator={<NavigateNextIcon fontSize="small" />}
          >
            {place?.parent !== null && (
              <Link
                underline="none"
                color="inherit"
                sx={{ fontStyle: "italic", fontWeight: 600 }}
              >
                {parentName}
              </Link>
            )}
            <Link
              underline="none"
              color="inherit"
              sx={{ fontStyle: "italic", fontWeight: 600 }}
            >
              {place?.name}
            </Link>
          </Breadcrumbs>
          <Divider sx={{ my: 2 }} />
          <CreatePlaceDialog
            place={place}
            addresses={addresses}
            handleAddNewPlace={handleUpdatePlace}
            doesUserHavePermission={doesUserHavePermission}
          />
          <Button
            type="primary"
            variant="contained"
            onClick={() => handleAddSubPlace(place?.system_id)}
            sx={{ my: 3 }}
          >
            <AddIcon />
            {`Add Place to ${place?.name}`}
          </Button>
        </Stack>
      )}
    </Container>
  );
};

export default DisplayPlaceForm;
